import * as React from 'react';
import RecordView from './RecordView';
import RecordsForDay from '../logic/domain/transits/RecordsForDay';
import { addPath } from '../logic/service/RecordsForMonthService';
import pathToUpdate from 'src/logic/type/pathToUpdate';

interface Props {
  recordForDay: RecordsForDay;
  handleCreateRecord: Function;
  handleUpdateRecord: Function;
  handleDeleteRecord: Function;
  handleCost: Function;
  pathToUpdate: pathToUpdate;
}

const dayView = (props: Props) => {
  const width100percent = {
    width: '100%'
  };
  const marginBottom = {
    marginBottom: '20px'
  };
  const {
    recordForDay,
    handleCreateRecord,
    handleUpdateRecord,
    handleDeleteRecord,
    handleCost,
    pathToUpdate
  } = props;

  return recordForDay.records.length > 0 ? (
    <div>
      <div className="card" style={marginBottom}>
        <header className="card-header has-background-primary">
          <p className="card-header-title has-text-white">
            {recordForDay.date}
          </p>
        </header>
        <div className="card-content">
          <table className="table" style={width100percent}>
            <thead>
              <tr>
                <th>No</th>
                <th>手段</th>
                <th>From</th>
                <th>To</th>
                <th>経路</th>
                <th>金額</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {recordForDay.records.map((item, index) => {
                const path = addPath(pathToUpdate, ['records', index]);
                return (
                  <RecordView
                    key={`${index}+${item.from.startTime}`}
                    index={index + 1}
                    record={item}
                    handleUpdateRecord={handleUpdateRecord}
                    handleDeleteRecord={handleDeleteRecord}
                    handleCost={handleCost}
                    pathToUpdate={path}
                  />
                );
              })}
            </tbody>
          </table>
        </div>
        <footer className="card-footer">
          <p className="card-footer-item">
            <span>
              <button
                className="button is-primary"
                onClick={e =>
                  handleCreateRecord(addPath(pathToUpdate, ['records']))
                }
              >
                <span className="icon">
                  <i className="fas fa-plus" />
                </span>
                <span>add New Transits</span>
              </button>
            </span>
          </p>
        </footer>
      </div>
    </div>
  ) : (
    <div />
  );
};

export default dayView;



// WEBPACK FOOTER //
// ./src/components/DayView.tsx